import React from 'react';
import PropTypes from 'prop-types';
import css from './Avatar.css';

export default class Avatar extends React.Component {

  get imageStyle() {
    const backgroundColor = this.props.isMobile ? "#D6EAF8" : null;
    return { backgroundImage: `url(${this.props.photoURL})`, backgroundColor };
  }

  render() {
    return (
      <div className={css['image']} style={this.imageStyle} id='profileImg'/>
    );
  }
}

Avatar.propTypes = {
  photoURL: PropTypes.string.isRequired,
  isMobile: PropTypes.bool
};
